import 'angular';

import { downgradeInjectable } from '@angular/upgrade/static';

import { TemplatedWordingService }      from './templated-wording.service';

angular.module('app-lite.templates', [])
.service('templatedWording', downgradeInjectable(TemplatedWordingService));
